module.exports = __webpack_public_path__ + "img/OfferList.1010a273.png";